import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var layout = function layout(overrides) {
  return _objectSpread({
    gapFactor: space(2),
    mobileBreakpoint: 480,
    tabletBreakpoint: 768,
    desktopBreakpoint: 1024,
    widescreenBreakpoint: 1200,
    fullHDBreakpoint: 1440,
    minorUnit: 4,
    majorUnit: 8
  }, _get(overrides, 'layout', {}));
};

export default layout;